var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTextbtnArrow19 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M0 0h8v14H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-639-852h1920V966H-639z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  d: "m1 1 6 6-6 6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#E9E9E9",
  d: "M-342.5-26.5h373v67h-373z"
})));
export default SvgIconTextbtnArrow19;